import React, { useState } from "react";
import BaseModal from "../BaseModal";
import Button from "../../Buttons/Button";
import CheckBox from "../../Checkbox";
import "./style.css";

/**
 * Modal for Filtering Patients
 * @param {function} onClose - Function to handle the modal close event
 */

export const PatientsFilter = ({ onClose }) => {
  // Replace with actual API call to fetch options
  const [options, setOptions] = useState({
    cancerType: [
      "Bladder Cancer",
      "Breast Cancer",
      "Endometrial Cancer",
      "Kidney Cancer",
      "Leukemia",
      "Prostate Cancer",
      "Thyroid Cancer",
      "Melanoma",
      "Liver Cancer",
      "Lung Cancer",
      "Non - Hodgkin Lymphoma",
      "Pancreatic Cancer",
      "Cervical Cancer",
    ],
    recentActivity: [
      "Reports XYZ Available",
      "Opinion Requested by Patient",
      "New Message by Patient",
      "New Message by Doctor",
    ],
    starredPatient: ["Starred Patients"],
    patientType: ["Primary", "Referred"],
    duration: ["Weekly", "Monthly", "Quarterly", "Select Date", "Custom Range"],
  });

  const [selectedOptions, setSelectedOptions] = useState({
    cancerType: [],
    recentActivity: [],
    starredPatient: [],
    patientType: [],
    duration: [],
  });

  const handleCheckboxChange = (category, value) => {
    setSelectedOptions((prevSelectedOptions) => {
      // If the category already exists in the selected options
      if (prevSelectedOptions.hasOwnProperty(category)) {
        // Check if the value is already in the array
        if (prevSelectedOptions[category].includes(value)) {
          // If yes, remove it
          return {
            ...prevSelectedOptions,
            [category]: prevSelectedOptions[category].filter(
              (item) => item !== value
            ),
          };
        } else {
          // If not, add it
          return {
            ...prevSelectedOptions,
            [category]: [...prevSelectedOptions[category], value],
          };
        }
      } else {
        // If the category doesn't exist, create a new array with the value
        return {
          ...prevSelectedOptions,
          [category]: [value],
        };
      }
    });
  };

  const [isFiltered, setIsFiltered] = useState(false);

  const handleCancel = () => {
    //Logic for cancel goes here
    onClose();
  };

  // Event handler for when the user clicks the "Apply" button
  const handleApplyFilter = async (event) => {
    try {
      // Replace with your actual API call
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // After successful delete, set the state to show FlyerMessage
      setIsFiltered(true);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  // Event handler for when the user clicks the "Close" button on FlyerMessage
  const handleFlyerMessageClose = () => {
    onClose();
    // Reset the state to hide FlyerMessage
    setIsFiltered(false);
  };

  return (
    //Reusable BaseModal - pass props : title and onClose
    <BaseModal
      title="Patients Filter"
      onClose={onClose}
      showFlyerMessage={isFiltered}
      flyerMessageText={"Filter has been applied successfully"}
      onFlyerMessageClose={handleFlyerMessageClose}
    >
      <div className="filter-column">
        <div className="filter-column-text">Cancer Type</div>
        <div className="filter-column-text">Recent Activity</div>
        <div className="filter-column-text">Starred Patients</div>
        <div className="filter-column-text">Primary/Referred</div>
        <div className="filter-column-text">Duration (From-To)</div>
      </div>

      <div className="filter-items">
        {Object.keys(options).map((category, index) => (
          <div className="filter-items-group" key={index}>
            {options[category].map((text, i) => (
              <CheckBox
                key={i}
                className="check-box-instance"
                label
                stateProp="default"
                text={text}
                toggle={false}
                onChange={(value) => handleCheckboxChange(category, value)}
              />
            ))}
          </div>
        ))}
      </div>

      <div className="filter-btn-group">
        {/* Reusable component Button - props btnType & onClick*/}
        <Button btnType="apply" onClick={handleApplyFilter} />
        <Button btnType="cancelWithIconAtFront" onClick={handleCancel} />
      </div>
    </BaseModal>
  );
};

export default PatientsFilter;
